module.exports = "../../app/cells/components/billing/billing_top_bar_cell.rb";